import * as React from 'react';
import { SVGProps } from 'react';

const SvgMarketperform = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <rect width={32} height={32} rx={16} fill="#FFD28A" />
    <path
      d="M7.86 20h1.138v-5.01h.034L11.063 20h.855l2.031-5.01h.04V20h1.132v-7.046h-1.455l-2.158 5.381h-.034l-2.159-5.38H7.86V20Zm10.835-7.046h-1.103l-1.846 8.755h1.099l1.85-8.755Zm.65 7.046h1.26v-2.33h1.455c1.425 0 2.397-.946 2.397-2.353v-.01c0-1.41-.972-2.353-2.397-2.353h-2.715V20Zm2.402-6.016c.903 0 1.43.484 1.43 1.329v.01c0 .844-.527 1.332-1.43 1.332h-1.142v-2.67h1.142Z"
      fill="#174174"
    />
  </svg>
);

export default SvgMarketperform;
